import { useEffect } from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";

import { useMetaAttributionStore } from "@/stores";

export const useMetaAttribution = () => {
  const navigate = useNavigate();
  const search = useSearch({ strict: false });
  const setMetaAttribution = useMetaAttributionStore((s) => {
    return s.setMetaAttribution;
  });

  const { fbc, fbclid, fbp } = search;

  useEffect(() => {
    if (!fbp && !fbc && !fbclid) {
      return;
    }

    setMetaAttribution({ fbp, fbc, fbclid });

    void navigate({
      to: ".",
      search: (prev: Record<string, unknown>) => {
        const { fbc: _fbc, fbclid: _fbclid, fbp: _fbp, ...rest } = prev;

        return rest;
      },
      replace: true,
    });
  }, [fbp, fbc, fbclid, navigate, setMetaAttribution]);
};
